import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

@JsonApiModelConfig({
  type: 'features',
})
export class FeatureFlag extends JsonApiModel {
  @Attribute()
  key!: string;

  @Attribute()
  enabled!: boolean;
}
